export default {
  time_options: {
    asap: {
      title: 'Zo snel mogelijk',
      description: 'Klaar over {{time}} min',
    },
    scheduled: {
      title: 'Later inplannen',
    },
  },
};
